import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is telecom software development?",
    answer: `<p>Telecom software is a set of tools used to organize, control, and facilitate the operation and delivery of telecommunications services. It includes features of network administration, billing, and customer service, including a call center.</p>`,
  },
  {
    question:
      "Why choose Tekrevol as your telecom software development company?",
    answer: ` <p>With years of experience and modern technology at our disposal, TekRevol emerges as the ideal telecom software development solutions provider. We are committed to your success and strive to give only the best results in each project we undertake.</p>`,
  },
  {
    question: "How much does it cost to build telecom software?",
    answer: `<p>The estimated cost for developing a telecom mobile app typically ranges from $40,000 to $300,000 or even higher. As a specialized telecom software development firm, our team is ready to provide you with a free consultation to determine the exact pricing for your project.</p>`,
  },
  {
    question: "How long does it take to build a telecom software?",
    answer: `<p>Telecom software might take 6 to 15 months or longer depending on the complexity, functionality, and architecture of the project.</p>`,
  },
  {
    question: "How does the cloud allow the telecom industry to grow?",
    answer: `<p>With the use of cloud technology, operators may save expenses, improve operational effectiveness, and offer cutting-edge client services, all of which contribute to their ability to compete successfully on the global stage.</p>`,
  },
  {
    question:
      "Does Tekrevol work with existing telecommunication software or only develop solutions from scratch?",
    answer: `<p>TekRevol provides telecom software development services for creating brand-new telecom solutions as well as for updating already-existing software. In addition to offering custom apps to satisfy your unique needs, our goal is to improve your present setup.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Telecom Software Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
